/**
 * Created by Christof Sander on 27.09.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'trees'
	],

	methods: {
		sanitizeResources(storage){
			var self = this;
			var resources = {
				initialized: false,
				trees: [
					{
						name: 'Newsletter ...',
						tree: [],
						nodes: {}
					}
				]
			};
			var tree = resources.trees[0].tree;
			var nodes = resources.trees[0].nodes;
			var id;

			if(this.resourceData.data && !this.resourceData.initialized) {
				this.resetNodeMappings();
				self.config.extendedTreeView = this.hasRoleOption('extendedTreeView');

				utils.forEach(this.resourceData.data, function (newsletterData) {
					resources.initialized = true;
					if(newsletterData.attributes) {
						var newsletter = newsletterData.attributes;
						var parent = '#';
						var primaryKey = newsletterData.attributes[newsletterData.primaryKey || 'id'] || 0;

						id = self.transformIDToIndex(primaryKey, 'newsletter', 0, tree.length);

						// estimate right text for this leaf
						var text = newsletter.name + ' (' + newsletter.code + ')';

						tree.push({
							id: id,
							parent: parent,
							text: text + (self.config.isComponentUsageAdmin ? ' [' + primaryKey + ']' : ''),
							type: 'newsletter',
							state: {
								opened: true,
								disabled: false,
								selected: false
							},
							li_attr: {},
							a_attr: {}
						});
						nodes[id] = newsletter;
						nodes[id]._primaryKey = primaryKey;

						// add layouts to tree
						utils.forEach(((newsletterData.children || {}).nl_newsletters_templates || {}).data || [], function (newsletterTemplateData) {
							var templateData = ((newsletterTemplateData.children || {}).cms_templates || {}).data || {};
							var templateTitle = 'Layout';
							var templateID = newsletterTemplateData.attributes.templateID;
							var newsletterTemplateID = newsletterTemplateData.attributes.newsletterTemplateID;
							utils.forEach(((templateData.relationships || {}).cms_templatesTrl || {}).data || [], function (templateTrlData) {
								if(templateTrlData.attributes.langCode == storage.langCode && !utils.isEmpty(templateTrlData.attributes.name)){
									templateTitle = templateTrlData.attributes.name;
									return false;
								}
							});

							var layoutID = self.transformIDToIndex(newsletterTemplateID, 'layout', 0, tree.length);

							tree.push({
								id: layoutID,
								parent: id,
								text: templateTitle + (self.config.isComponentUsageAdmin ? ' [' + templateID + ']' : ''),
								type: 'layout',
								state: {
									opened: true,
									disabled: false,
									selected: false
								},
								li_attr: {},
								a_attr: {}
							});
							nodes[layoutID] = templateData.attributes || {};
						});
					}
				});

				this.resourceData = resources;
			}
		},

		// operations
		showInsert: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			if(this.actions[baseActionKey]){
				this.deselectActiveNode();
				return this.performAndStoreAction(baseActionKey);
			}

			return utils.promise.reject();
		},

		// operations
		showDuplicate: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var nodeData    = this.getSelectedNodeData();

			if(this.actions[baseActionKey] && nodeData._primaryKey){
				return this.performAction(
					this.prepareAction(baseActionKey, nodeData._primaryKey)
				);
			}

			return utils.promise.reject();
		},

		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var self = this;

			return self.performDecision(
				'confirm',
				{
					component:  self,
					title:      storage.__('hint.delete.really.' + buttonContext + '.title'),
					message:    storage.__('hint.delete.really.' + buttonContext + '.message')
				}
			).then(function(context) {
				if (context.decision.type === 'yes') {
					var nodeID = self.getSelectedNodeID();
					var nodeIndex = self.getSelectedNodeIndex();
					if(self.actions[baseActionKey] && !utils.isEmpty(nodeID)){
						self.setClosestNodeAsReady(nodeIndex);
						self.deselectActiveNode();
						return self.performAction(
							self.prepareAction(baseActionKey, nodeID)
						).then(function(context){
							self.refreshTrees();
							return context;
						});
					}
				}

				return utils.promise.reject();
			});
		},

		/**
		 * support multiple action forms.
		 *
		 * @param data      {} - onTreeAction trigger context
		 */
		onTreeAction: function (data) {
			var self = this;
			var actionFormsSelector = '.base_treesManagement_actionsForm';

			switch (data.onTreeActionOptions.eventType) {
				case 'select_node.jstree':
					// TODO: impl. animation and animation-delay
					// show page actions if necessary
					this.$.find(actionFormsSelector).hide();
					var selector = '.newsletterTreesActions';
					if(data.onTreeActionOptions.eventData.node.type === 'layout'){
						selector = '.newsletterTreesLayoutActions';
						this.$.find('.base_treesManagement_propertiesForm').hide();
					}
					this.$.find(selector).show();
					break;

				case 'deselect_node.jstree':
					// hide page actions if necessary
					this.$.find(actionFormsSelector).hide();
					break;
			}
		}
	},

	hooks: {
		async onDecision($element, options){
			switch(options.decisionType){
				case 'submit':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							var modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component;
							if(modalContentComponent && modalContentComponent.hasClass('templates_propertiesForms_newsletterPropertiesForm')){
								await modalContentComponent.submit()
                                await options.decisionComponent.hide()
							}
							break;


						case 'templates_layoutTrees_selectLayoutTrees':
							var nodeData    = this.getSelectedNodeData();

							await this.performAction(this.prepareAction('assign_layout', undefined, undefined, {
								source: {
									submit: {
										data: {
											data: {
												attributes: {
													newsletterID: 	nodeData._primaryKey || nodeData.id,
													templateID: 	options.data._primaryKey || options.data.id
												}
											}
										}
									}
								}
							}))
                            options.decisionComponent.closest('base_modal_modal', async (modalComponent) => {
                                await modalComponent.hide();
                                this.refreshTrees();
                            });
							break;
					}
					break;

				case 'cancel':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							await options.decisionComponent.hide();
							break;
					}
					break;

				default:
					// TODO: ERROR;
					break;
			}
		}
	},

	handlers: [
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_newsletterPropertiesForm',
			handle: function(callerComponent){
				this.deselectActiveNode();
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_newsletterPropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				if(insertPerformed){
					this.config.readyNodeID       = ((nodeData.data || {}).attributes || {})[(nodeData.data || {}).primaryKey];
					this.config.readyNodeContext  = 'newsletter';
				}
				this.refreshTrees();
			}
		}
	]
};
